import { SupervisorOverviewParams } from "../store/supervisor-home-types";

function pad(value: number, length = 2): string {
	return String(Math.abs(value)).padStart(length, "0");
}

// Formats a local Date as ISO 8601 carrying the local UTC offset, e.g.
// "2026-07-16T00:00:00.000+05:30". GET /companies/supervisors/overview needs
// `todayStart`/`todayEnd` in this shape so it can scope "today" to the
// supervisor's own day rather than a UTC day.
function toLocalIsoWithOffset(date: Date): string {
	const offsetMinutes = -date.getTimezoneOffset();
	const sign = offsetMinutes >= 0 ? "+" : "-";
	const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
	const offsetMins = pad(Math.abs(offsetMinutes) % 60);

	return (
		`${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
		`T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}` +
		`.${pad(date.getMilliseconds(), 3)}${sign}${offsetHours}:${offsetMins}`
	);
}

export const REQUESTS_WINDOW_OPTIONS = [7, 14, 30] as const;

export const DEFAULT_REQUESTS_WINDOW_DAYS = 7;

// Builds the query params for the overview call: a UTC window for pending
// requests, plus today's local-day boundaries for the shifts-today and
// on/off-shift counts.
export function buildOverviewParams(
	windowDays: number = DEFAULT_REQUESTS_WINDOW_DAYS,
	now: Date = new Date()
): SupervisorOverviewParams {
	const startOfToday = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		0,
		0,
		0,
		0
	);
	const endOfToday = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		23,
		59,
		59,
		999
	);
	const windowStart = new Date(startOfToday);
	// A 7-day window is today plus the six days before it.
	windowStart.setDate(windowStart.getDate() - (windowDays - 1));

	return {
		startDate: windowStart.toISOString(),
		endDate: endOfToday.toISOString(),
		todayStart: toLocalIsoWithOffset(startOfToday),
		todayEnd: toLocalIsoWithOffset(endOfToday),
	};
}
